var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.999,
    viewBox: "0 0 24 15.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-camera-alt",
    d: "M22.9,6.538a1.97,1.97,0,0,0-2.077.188,1.009,1.009,0,0,0-.11.1L18.959,8.6A4.99,4.99,0,0,0,14,4H5A5,5,0,0,0,0,9v6a5.006,5.006,0,0,0,5,5h9a4.99,4.99,0,0,0,4.962-4.627l1.756,1.754a1.178,1.178,0,0,0,.107.092A1.985,1.985,0,0,0,24,15.632V8.314a1.972,1.972,0,0,0-1.1-1.775ZM14,18H5a3,3,0,0,1-3-3V9A3,3,0,0,1,5,6h9a3,3,0,0,1,3,3v6A3,3,0,0,1,14,18Zm5-5.417V11.394l3-3.028.025,7.238L19,12.582Z",
    transform: "translate(0 -4.001)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraAlt);
export default __webpack_public_path__ + "static/media/video-camera-alt.258d8cc8e829472bb24a76ca9d55cecc.svg";
export { ForwardRef as ReactComponent };